'use strict';
import * as $j_com$002eraquo$002elaminar$002e$002dDom$002dApi$0024 from "./com.raquo.laminar.-Dom-Api$.js";
import * as $j_com$002eraquo$002elaminar$002eapi$002e$002dImplicits from "./com.raquo.laminar.api.-Implicits.js";
import * as $j_com$002eraquo$002elaminar$002emodifiers$002e$002dRenderable$002dText$0024 from "./com.raquo.laminar.modifiers.-Renderable-Text$.js";
import * as $j_dev$002echeleb$002escalamigen$002e$002dValidation$002dStatus$0024$002dInvalid from "./dev.cheleb.scalamigen.-Validation-Status$-Invalid.js";
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
import * as $j_scala$002eruntime$002e$002dAbstract$002dPartial$002dFunction from "./scala.runtime.-Abstract-Partial-Function.js";
var $p;
/** @constructor */
function $c_Lsamples_Persons$package$$anon$37() {
}
export { $c_Lsamples_Persons$package$$anon$37 as $c_Lsamples_Persons$package$$anon$37 };
$p = $c_Lsamples_Persons$package$$anon$37.prototype = new $j_scala$002eruntime$002e$002dAbstract$002dPartial$002dFunction.$h_sr_AbstractPartialFunction();
$p.constructor = $c_Lsamples_Persons$package$$anon$37;
/** @constructor */
function $h_Lsamples_Persons$package$$anon$37() {
}
export { $h_Lsamples_Persons$package$$anon$37 as $h_Lsamples_Persons$package$$anon$37 };
$h_Lsamples_Persons$package$$anon$37.prototype = $p;
$p.gz = (function(x) {
  if ((x !== null)) {
    var x69 = x.ad;
    if ((x69 instanceof $j_dev$002echeleb$002escalamigen$002e$002dValidation$002dStatus$0024$002dInvalid.$c_Ldev_cheleb_scalamigen_ValidationStatus$Invalid)) {
      if (x69.g5) {
        return true;
      }
    }
  }
  return false;
});
$p.gt = (function(x, default$1) {
  if ((x !== null)) {
    var x76 = x.ad;
    var field = x.ac;
    if ((x76 instanceof $j_dev$002echeleb$002escalamigen$002e$002dValidation$002dStatus$0024$002dInvalid.$c_Ldev_cheleb_scalamigen_ValidationStatus$Invalid)) {
      var x79 = x76.hB;
      if (x76.g5) {
        return $j_com$002eraquo$002elaminar$002e$002dDom$002dApi$0024.$m_Lcom_raquo_laminar_api_package$().d.U().u($j_java$002elang$002e$002dObject.$ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $j_java$002elang$002e$002dObject.$c_sjsr_WrappedVarArgs(), [$j_com$002eraquo$002elaminar$002eapi$002e$002dImplicits.$f_Lcom_raquo_laminar_api_Implicits__textToTextNode__O__Lcom_raquo_laminar_modifiers_RenderableText__Lcom_raquo_laminar_nodes_TextNode($j_com$002eraquo$002elaminar$002e$002dDom$002dApi$0024.$m_Lcom_raquo_laminar_api_package$().d, ((field + ": ") + x79), $j_com$002eraquo$002elaminar$002emodifiers$002e$002dRenderable$002dText$0024.$m_Lcom_raquo_laminar_modifiers_RenderableText$().a9)]));
      }
    }
  }
  return default$1.j(x);
});
$p.de = (function(x) {
  return this.gz(x);
});
$p.cr = (function(x, default$1) {
  return this.gt(x, default$1);
});
var $d_Lsamples_Persons$package$$anon$37 = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Lsamples_Persons$package$$anon$37, "samples.Persons$package$$anon$37", ({
  pT: 1,
  aO: 1,
  o: 1,
  t: 1,
  a: 1
}));
export { $d_Lsamples_Persons$package$$anon$37 as $d_Lsamples_Persons$package$$anon$37 };
